import axios from "axios";
export const Role = (role) => async (dispatch) => {
  try {
    dispatch({ type: "CHANGE_ROLE", payload: { role } });
  } catch (error) {}
};
export const Status = (status) => async (dispatch) => {
  try {
    dispatch({ type: "CHANGE_STATUS", payload: { status } });
  } catch (error) {}
};
